module.exports = __webpack_public_path__ + "img/mmh_martaintoken.41a60e5.png";